import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { settingsCallManagement } from "../../../../../../hooks/api/SettingsCallManagement";

const AddStatus = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useAddStatusMutation } = settingsCallManagement;
    const [addStatus] = useAddStatusMutation();

    const tabs = [
        { title: t('calls.appointment'), onClick: () => gotoAppointmentTab() },
        { title: t("calls.courseType"), onClick: () => gotoCourseTypeTab() },
        { title: t("calls.methodOfContact"), onClick: () => gotoMethodOfContactTab() },
        { title: t("calls.salesChannel"), onClick: () => gotoSalesChannelTab() },
        { title: t("calls.studentStatus"), onClick: () => gotoStudentStatusChannelTab() },
        { title: t("calls.status"), isActive: true },
        { title: t("calls.offerSent"), onClick: () => gotoOfferSentTab() },
    ];

    const gotoOfferSentTab = () => {
        navigate("/settings/calls/offer-sent");
    };

    const gotoAppointmentTab = () => {
        navigate("/settings/calls/appointments");
    };

    const gotoCourseTypeTab = () => {
        navigate("/settings/calls/course-type");
    };

    const gotoMethodOfContactTab = () => {
        navigate("/settings/calls/method-of-contact");
    };

    const gotoSalesChannelTab = () => {
        navigate("/settings/calls/sales-channel");
    };

    const gotoStudentStatusChannelTab = () => {
        navigate("/settings/calls/student-status");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        if (values?.contactPerson === "") {
            values.contactPerson = null;
        }
        addStatus(values).then((result) => {            
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/calls/status");
            }
        });
    };

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/calls/status" />
                <Button title={t("save")} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("calls.title")} />
                    <Link title={t("calls.status")} />
                    <Link title={t("calls.addStatus")} isActive={true} />
                </Breadcrumps>
                    <Formik
                        innerRef={formRef}
                        initialValues={{
                            status: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="status"
                                        label={t("status")}
                                        required={true}
                                        value={values.status}
                                        onChange={handleChange}
                                        error={formErrors?.status}
                                    />
                                </Field>
                                
                            </Row>
                            
                            
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddStatus;
